import assertNever from "../../../../global/assetNever";
import {ListViewContentElementType} from "../../../enums/listViews/listViewContentElementType";
import {StringHelper} from "../../../helpers/stringHelper";
import {ListViewContentElementLayoutType} from "../../../enums/listViews/listViewContentElementLayoutType";
import {ListViewContentElementControlType} from "../../../enums/listViews/listViewContentElementControlType";
import {SizeType} from "../../../enums/sizeType";

export default class ListViewContentElementDefinition {
  static getComponent(contentType: ListViewContentElementType): string {
    switch (contentType) {
      case ListViewContentElementLayoutType.Row:
        return 'content-element-row';
      case ListViewContentElementLayoutType.Column:
        return 'content-element-column';
      case ListViewContentElementLayoutType.ActionsColumn:
        return 'content-element-actions-column';
      case ListViewContentElementLayoutType.Action:
        return 'content-element-action';
      case ListViewContentElementControlType.ModelProperty:
        return 'content-element-model-property';
      case ListViewContentElementControlType.CompositeText:
        return 'content-element-composite-text';
      case ListViewContentElementControlType.Formula:
        return 'content-element-formula';
      case ListViewContentElementControlType.IconSet:
        return 'content-element-icon-set';
      default:
        assertNever(contentType);
    }
  }

  static getDisplayName(contentType: ListViewContentElementType): string {
    switch (contentType) {
      case ListViewContentElementLayoutType.Row:
        return 'Row';
      case ListViewContentElementLayoutType.Column:
        return 'Column';
      case ListViewContentElementLayoutType.ActionsColumn:
        return 'Actions Column';
      case ListViewContentElementLayoutType.Action:
        return 'Action';
      case ListViewContentElementControlType.ModelProperty:
        return 'Model Property';
      case ListViewContentElementControlType.CompositeText:
        return 'Composite Text';
      case ListViewContentElementControlType.Formula:
        return 'Formula';
      case ListViewContentElementControlType.IconSet:
        return 'Icon Set';
      default:
        assertNever(contentType);
    }
  }

  static getIcon(contentType: ListViewContentElementType): string {
    switch (contentType) {
      case ListViewContentElementLayoutType.Row:
        return '';
      case ListViewContentElementLayoutType.Column:
        return '';
      case ListViewContentElementLayoutType.ActionsColumn:
        return '';
      case ListViewContentElementLayoutType.Action:
        return '';
      case ListViewContentElementControlType.ModelProperty:
        return 'dynamic-field';
      case ListViewContentElementControlType.CompositeText:
        return 'text';
      case ListViewContentElementControlType.Formula:
        return 'florin';
      case ListViewContentElementControlType.IconSet:
        return 'icon-set';
      default:
        assertNever(contentType);
    }
  }

  static getComponentClass(contentType: ListViewContentElementType): string {
    return `builder-element element-${StringHelper.toDash(ListViewContentElementDefinition.getDisplayName(contentType))} lvce-${StringHelper.toDash(ListViewContentElementDefinition.getDisplayName(contentType))}`;
  }

  static getControlGroups(): { name: string, icon: string, type: ListViewContentElementControlType }[] {
    return [
      {
        name: ListViewContentElementDefinition.getDisplayName(ListViewContentElementControlType.ModelProperty),
        icon: ListViewContentElementDefinition.getIcon(ListViewContentElementControlType.ModelProperty),
        type: ListViewContentElementControlType.ModelProperty,
      },
      {
        name: ListViewContentElementDefinition.getDisplayName(ListViewContentElementControlType.CompositeText),
        icon: ListViewContentElementDefinition.getIcon(ListViewContentElementControlType.CompositeText),
        type: ListViewContentElementControlType.CompositeText,
      },
      {
        name: ListViewContentElementDefinition.getDisplayName(ListViewContentElementControlType.Formula),
        icon: ListViewContentElementDefinition.getIcon(ListViewContentElementControlType.Formula),
        type: ListViewContentElementControlType.Formula,
      },
      {
        name: ListViewContentElementDefinition.getDisplayName(ListViewContentElementControlType.IconSet),
        icon: ListViewContentElementDefinition.getIcon(ListViewContentElementControlType.IconSet),
        type: ListViewContentElementControlType.IconSet,
      },
    ];
  }

  static getWorkAreaTitle(contentType: ListViewContentElementType): string {
    switch (contentType) {
      case ListViewContentElementLayoutType.Row:
        return null;
      case ListViewContentElementLayoutType.Column:
        return null;
      case ListViewContentElementLayoutType.ActionsColumn:
        return null;
      default:
        return ListViewContentElementDefinition.getDisplayName(contentType);
    }
  }

  static getFixedColumnWidthClass(sizeType: SizeType): number {
    switch (sizeType) {
      case SizeType.Sm:
        return 200;
      case SizeType.Lg:
        return 600;
      default:// SizeType.Md
        return 400;
    }
  }

  static getDynamicColumnWidthClass(sizeType: SizeType): string {
    switch (sizeType) {
      case SizeType.Sm:
        return 'sz4b12';
      case SizeType.Lg:
        return 'sz12b12';
      default:// SizeType.Md
        return 'sz8b12';
    }
  }
}